"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = exports.otherQueries = exports.cardiologyQueries = exports.consultationQueries = exports.tomourResearchQueries = exports.imagingProcedureQueries = exports.mandatoryLabProcedures = exports.labProcedureQueries = exports.complexTypeLabProcedureQueries = exports.posNegTypeLabProcedureQueries = exports.summaryTypeLabProcedureQueries = exports.numberTypeLabProcedureQueries = exports.covidQueries = exports.medicalHistoryQueries = exports.waitingListQueries = exports.viralSerologyQueries = exports.mandatoryViralSerologyQueries = exports.preImmunisationQueries = exports.qs = void 0;
exports.qs = {
    vAb0: {
        interpretation: {
            vocab: "ktx",
            code: "ab0"
        }
    },
    vRh: {
        interpretation: {
            vocab: "ktx",
            code: "rh"
        }
    },
    weight: {
        interpretation: {
            vocab: "ktx",
            code: "weight"
        }
    },
    height: {
        interpretation: {
            vocab: "ktx",
            code: "height"
        }
    },
    bmi: {
        interpretation: {
            vocab: "ktx",
            code: "bmi"
        },
        limit: Infinity
    },
    patientStatus: {
        interpretation: {
            vocab: "ktx",
            code: "patient_status"
        }
    },
    signedStatementOfConsentFyrms: {
        interpretation: {
            vocab: "ktx",
            code: "signed_statement_of_consent_fyrms"
        }
    },
    signedStatementOfConsentOvsz: {
        interpretation: {
            vocab: "ktx",
            code: "signed_statement_of_consent_ovsz"
        }
    },
    waitingListStartDate: {
        interpretation: {
            vocab: "ktx",
            code: "waiting_list_start_date"
        }
    },
    patientEtId: {
        interpretation: {
            vocab: "ktx",
            code: "patient_et_id"
        }
    },
    liveDonorScreening: {
        interpretation: {
            vocab: "ktx",
            code: "live_donor_screening"
        }
    }
};
exports.preImmunisationQueries = {
    previousOtherOrganTransplantation: {
        tags: [
            {
                vocab: "ktx",
                code: "previous_other_organ_transplantation"
            }
        ],
        limit: Infinity
    },
    combinedOrganTransplantation: {
        interpretation: {
            vocab: "ktx",
            code: "combined_organ_transplantation"
        },
        limit: Infinity
    },
    transfusion: {
        interpretation: {
            vocab: "ktx",
            code: "transfusion"
        },
        limit: Infinity
    },
    pregnanciesAndChildren: {
        interpretation: {
            vocab: "ktx",
            code: "pregnancies_and_children_statement"
        }
    }
};
exports.mandatoryViralSerologyQueries = {
    cmv: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_cmv"
        }
    },
    ebv: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_ebv"
        }
    },
    hbvStatus: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_hbv_status"
        }
    },
    hcv: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_hcv"
        }
    },
    toxoplasma: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_toxoplasma"
        }
    },
    varicella: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_varicella"
        }
    },
    hiv: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_hiv"
        }
    },
    treponemaPallidum: {
        interpretation: {
            vocab: "ktx",
            code: "microbiological_treponema_pallidum"
        }
    },
    viralSerology: {
        tags: [
            {
                vocab: "ktx",
                code: "microbiological_procedure"
            }
        ],
        limit: Infinity
    }
};
exports.viralSerologyQueries = {
    ...exports.mandatoryViralSerologyQueries
};
exports.waitingListQueries = {
    kidneyDiseaseEthiology: {
        tags: [
            {
                vocab: "ktx",
                code: "kidney_disease_ethiology"
            }
        ],
        limit: Infinity
    },
    renalReplacementTherapy: {
        tags: [
            {
                vocab: "ktx",
                code: "renal_replacement_therapy"
            }
        ],
        limit: 1
    },
    access: {
        tags: [
            {
                vocab: "ktx",
                code: "access"
            }
        ],
        limit: 1
    },
    graftloss: {
        tags: [
            {
                vocab: "ktx",
                code: "cause_of_graftloss"
            }
        ],
        limit: 1
    }
};
exports.medicalHistoryQueries = {
    hepatologyDisease: {
        tags: [
            {
                vocab: "ktx",
                code: "hepatology_disease"
            }
        ],
        limit: Infinity
    },
    metabolicDiseases: {
        tags: [
            {
                vocab: "ktx",
                code: "metabolic_disease_type"
            }
        ],
        limit: Infinity
    },
    diabetes: {
        interpretation: {
            vocab: "ktx",
            code: "diabetes"
        }
    },
    primaryHypertension: {
        interpretation: {
            vocab: "ktx",
            code: "primary_hypertension"
        }
    },
    secondaryHypertension: {
        interpretation: {
            vocab: "ktx",
            code: "secondary_hypertension"
        }
    },
    otherDisorders: {
        tags: [
            {
                vocab: "ktx",
                code: "medicine_diagnosis"
            }
        ],
        limit: Infinity
    },
    otherSurgicalInterventionType: {
        tags: [
            {
                vocab: "ktx",
                code: "other_surgical_intervention_type"
            }
        ],
        limit: Infinity
    },
    medicalTreatment: {
        interpretation: {
            vocab: "ktx",
            code: "medical_treatment_statement"
        }
    },
    cardiovascularDiseases: {
        tags: [
            {
                vocab: "ktx",
                code: "cardiovascular_disease_type"
            }
        ],
        limit: Infinity
    },
    nephrectomy: {
        tags: [
            {
                vocab: "ktx",
                code: "nephrectomy"
            }
        ],
        limit: Infinity
    },
    graftectomy: {
        tags: [
            {
                vocab: "ktx",
                code: "graftectomy"
            }
        ],
        limit: Infinity
    },
    oncologyDiseases: {
        tags: [
            {
                vocab: "ktx",
                code: "oncology_disease_type"
            }
        ],
        limit: Infinity
    },
    renalAnaemiaHematology: {
        tags: [
            {
                vocab: "ktx",
                code: "renal_anaemia_hematology_type"
            }
        ],
        limit: Infinity
    },
    haemostaseologyType: {
        tags: [
            {
                vocab: "ktx",
                code: "haemostaseology_type"
            }
        ],
        limit: Infinity
    },
    chronicLiverFailureHbv: {
        interpretation: {
            vocab: "ktx",
            code: "hbv_chronic_liver_failure_statement"
        }
    },
    chronicLiverFailureHcv: {
        interpretation: {
            vocab: "ktx",
            code: "hcv_chronic_liver_failure_statement"
        }
    },
    allergiesAndSensitivities: {
        interpretation: {
            vocab: "ktx",
            code: "sensitivities_and_allergies_statement"
        }
    },
    alcohol: {
        interpretation: {
            vocab: "ktx",
            code: "alcohol_statement"
        }
    },
    smoking: {
        interpretation: {
            vocab: "ktx",
            code: "smoking_statement"
        }
    }
};
exports.covidQueries = {
    vaccination: {
        tags: [
            {
                vocab: "ktx",
                code: "covid_vaccination_type"
            }
        ],
        limit: Infinity
    },
    disease: {
        interpretation: {
            vocab: "ktx",
            code: "covid_disease"
        }
    }
};
exports.numberTypeLabProcedureQueries = {
    albumin: {
        interpretation: {
            vocab: "ktx",
            code: "lab_albumin"
        }
    },
    alkalinePhosphatase: {
        interpretation: {
            vocab: "ktx",
            code: "lab_alkaline_phosphatase"
        }
    },
    bilirubinDirect: {
        interpretation: {
            vocab: "ktx",
            code: "lab_bilirubin_direct"
        }
    },
    bilirubinTotal: {
        interpretation: {
            vocab: "ktx",
            code: "lab_bilirubin_total"
        }
    },
    calcium: {
        interpretation: {
            vocab: "ktx",
            code: "lab_calcium"
        }
    },
    creatinine: {
        interpretation: {
            vocab: "ktx",
            code: "lab_creatinine"
        }
    },
    crp: {
        interpretation: {
            vocab: "ktx",
            code: "lab_CRP"
        }
    },
    ggt: {
        interpretation: {
            vocab: "ktx",
            code: "lab_ggt"
        }
    },
    got: {
        interpretation: {
            vocab: "ktx",
            code: "lab_got"
        }
    },
    gpt: {
        interpretation: {
            vocab: "ktx",
            code: "lab_gpt"
        }
    },
    haemoglobin: {
        interpretation: {
            vocab: "ktx",
            code: "lab_haemoglobin"
        }
    },
    hgbA1C: {
        interpretation: {
            vocab: "ktx",
            code: "lab_HgbA1C"
        }
    },
    inr: {
        interpretation: {
            vocab: "ktx",
            code: "lab_inr"
        }
    },
    karbamid: {
        interpretation: {
            vocab: "ktx",
            code: "lab_urea_nitrogen"
        }
    },
    natrium: {
        interpretation: {
            vocab: "ktx",
            code: "lab_sodium"
        }
    },
    phosphate: {
        interpretation: {
            vocab: "ktx",
            code: "lab_phosphate"
        }
    },
    potassium: {
        interpretation: {
            vocab: "ktx",
            code: "lab_potassium"
        }
    },
    psa: {
        interpretation: {
            vocab: "ktx",
            code: "lab_PSA"
        }
    },
    t3: {
        interpretation: {
            vocab: "ktx",
            code: "lab_T3"
        }
    },
    t4: {
        interpretation: {
            vocab: "ktx",
            code: "lab_T4"
        }
    },
    tsh: {
        interpretation: {
            vocab: "ktx",
            code: "lab_TSH"
        }
    },
    urineProteinCreatinineRatio: {
        interpretation: {
            vocab: "ktx",
            code: "lab_urine_protein_creatinine_ratio"
        }
    },
    eGFR: {
        interpretation: {
            vocab: "ktx",
            code: "lab_eGFR"
        }
    },
    fastingGlucose: {
        interpretation: {
            vocab: "ktx",
            code: "lab_fasting_glucose"
        }
    },
    ferritine: {
        interpretation: {
            vocab: "ktx",
            code: "lab_ferritine"
        }
    },
    hgbA1CCalculated: {
        interpretation: {
            vocab: "ktx",
            code: "lab_HbA1c_calculated"
        }
    },
    iPth: {
        interpretation: {
            vocab: "ktx",
            code: "lab_iPTH"
        }
    },
    ldlCholesterol: {
        interpretation: {
            vocab: "ktx",
            code: "lab_LDL_cholesterol"
        }
    },
    serumIron: {
        interpretation: {
            vocab: "ktx",
            code: "lab_serum_iron"
        }
    },
    thrombocyte: {
        interpretation: {
            vocab: "ktx",
            code: "lab_thrombocyte"
        }
    },
    totalCholesterol: {
        interpretation: {
            vocab: "ktx",
            code: "lab_total_cholesterol"
        }
    },
    totalIronBindingCapacity: {
        interpretation: {
            vocab: "ktx",
            code: "lab_total_iron_binding_capacity"
        }
    },
    totalProtein: {
        interpretation: {
            vocab: "ktx",
            code: "lab_total_protein"
        }
    },
    transferrinSaturation: {
        interpretation: {
            vocab: "ktx",
            code: "lab_transferrin_saturation"
        }
    },
    triglyceride: {
        interpretation: {
            vocab: "ktx",
            code: "lab_triglyceride"
        }
    },
    urate: {
        interpretation: {
            vocab: "ktx",
            code: "lab_urate"
        }
    },
    whiteBloodCellCount: {
        interpretation: {
            vocab: "ktx",
            code: "lab_white_blood_cell_count"
        }
    },
    restDiuresis: {
        interpretation: {
            vocab: "ktx",
            code: "lab_rest_diuresis"
        }
    }
};
exports.summaryTypeLabProcedureQueries = {
    combinedKidneyPancreas: {
        interpretation: {
            vocab: "ktx",
            code: "lab_combined_kidney_pancreas"
        }
    },
    otherLabProcedure: {
        interpretation: {
            vocab: "ktx",
            code: "lab_other_procedure"
        }
    }
};
exports.posNegTypeLabProcedureQueries = {
    stoolBlood: {
        interpretation: {
            vocab: "ktx",
            code: "lab_stool_blood"
        }
    },
    stoolculture: {
        interpretation: {
            vocab: "ktx",
            code: "lab_stool_culture"
        }
    },
    urineculture: {
        interpretation: {
            vocab: "ktx",
            code: "lab_urine_culture"
        }
    }
};
exports.complexTypeLabProcedureQueries = {
    totalUrineAnalysis: {
        interpretation: {
            vocab: "ktx",
            code: "lab_total_urine_analysis"
        }
    }
};
exports.labProcedureQueries = {
    ...exports.numberTypeLabProcedureQueries,
    ...exports.posNegTypeLabProcedureQueries,
    ...exports.summaryTypeLabProcedureQueries,
    ...exports.complexTypeLabProcedureQueries
};
const { albumin, combinedKidneyPancreas, otherLabProcedure, stoolculture, t3, t4, urineProteinCreatinineRatio, ...rest } = exports.labProcedureQueries;
exports.mandatoryLabProcedures = rest;
exports.imagingProcedureQueries = {
    abdominalCtMrAngiography: {
        interpretation: {
            vocab: "ktx",
            code: "abdominal_CT_MR_angiography"
        }
    },
    abdominalPelvisUltrasound: {
        interpretation: {
            vocab: "ktx",
            code: "abdominal-pelvis_ultrasound"
        }
    },
    carotisDoppler: {
        interpretation: {
            vocab: "ktx",
            code: "carotis_doppler"
        }
    },
    chestCt: {
        interpretation: {
            vocab: "ktx",
            code: "chest_ct"
        }
    },
    chestXRay: {
        interpretation: {
            vocab: "ktx",
            code: "chest_x_ray"
        }
    },
    neckCtMrAngiography: {
        interpretation: {
            vocab: "ktx",
            code: "neck_CT_MR_angiography"
        }
    },
    nativeAbdominalXRay: {
        interpretation: {
            vocab: "ktx",
            code: "native_abdominal_x-ray"
        }
    },
    upperLimbCtMrAngiography: {
        interpretation: {
            vocab: "ktx",
            code: "upper_limb_CT_MR_angiography"
        }
    },
    lowerLimbCtMrAngiography: {
        interpretation: {
            vocab: "ktx",
            code: "lower_limb_CT_MR_angiography"
        }
    },
    craniumCtMrAngiography: {
        interpretation: {
            vocab: "ktx",
            code: "cranium_CT_MR_angiography"
        }
    },
    otherImagingProcedure: {
        interpretation: {
            vocab: "ktx",
            code: "other_imaging_procedure"
        }
    },
    upperLimbDoppler: {
        interpretation: {
            vocab: "ktx",
            code: "upper_limb_doppler"
        }
    }
};
exports.tomourResearchQueries = {
    colonoscopy: {
        interpretation: {
            vocab: "ktx",
            code: "colonoscopy"
        }
    },
    dermatology: {
        interpretation: {
            vocab: "ktx",
            code: "dermatology"
        }
    },
    dentalScreening: {
        interpretation: {
            vocab: "ktx",
            code: "dental_screening"
        }
    },
    earNoseThroat: {
        interpretation: {
            vocab: "ktx",
            code: "ear_nose_throat"
        }
    },
    mammography: {
        interpretation: {
            vocab: "ktx",
            code: "mammography"
        }
    },
    gynecology: {
        interpretation: {
            vocab: "ktx",
            code: "gynecology"
        }
    },
    ophthalmology: {
        interpretation: {
            vocab: "ktx",
            code: "ophthalmology"
        }
    },
    urology: {
        interpretation: {
            vocab: "ktx",
            code: "urology"
        }
    }
};
exports.consultationQueries = {
    neurology: {
        interpretation: {
            vocab: "ktx",
            code: "neurology"
        }
    },
    immunology: {
        interpretation: {
            vocab: "ktx",
            code: "immunology"
        }
    },
    diabetology: {
        interpretation: {
            vocab: "ktx",
            code: "diabetology"
        }
    },
    endocrinology: {
        interpretation: {
            vocab: "ktx",
            code: "endocrinology"
        }
    },
    vascularSurgery: {
        interpretation: {
            vocab: "ktx",
            code: "vascular_surgery"
        }
    },
    gastroenterology: {
        interpretation: {
            vocab: "ktx",
            code: "gastroenterology"
        }
    },
    genetics: {
        interpretation: {
            vocab: "ktx",
            code: "genetics"
        }
    },
    hematology: {
        interpretation: {
            vocab: "ktx",
            code: "hematology"
        }
    },
    hepatology: {
        interpretation: {
            vocab: "ktx",
            code: "hepatology"
        }
    },
    oncology: {
        interpretation: {
            vocab: "ktx",
            code: "oncology"
        }
    },
    psychiatry: {
        interpretation: {
            vocab: "ktx",
            code: "psychiatry"
        }
    },
    pulmonology: {
        interpretation: {
            vocab: "ktx",
            code: "pulmonology"
        }
    },
    transplantAnesthesiology: {
        interpretation: {
            vocab: "ktx",
            code: "transplant_anesthesiology"
        }
    },
    transplantNephrology: {
        interpretation: {
            vocab: "ktx",
            code: "transplant_nephrology"
        }
    },
    transplantSurgery: {
        interpretation: {
            vocab: "ktx",
            code: "transplant_surgery"
        }
    },
    cardiologyOpinion: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_opinion"
        }
    }
};
exports.cardiologyQueries = {
    cardiologyBikeErgometry: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_bike_ergometry"
        }
    },
    cardiologyCoronarography: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_coronarography"
        }
    },
    cardiologyCoronaryCt: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_coronary_ct"
        }
    },
    cardiologyDse: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_dse"
        }
    },
    cardiologyEkg: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_ekg"
        }
    },
    cardiologyHearthMri: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_hearth_mri"
        }
    },
    cardiologySpect: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_spect"
        }
    },
    cardiologyTranstorachalisEcho: {
        interpretation: {
            vocab: "ktx",
            code: "cardiology_transtorachalis_echo"
        }
    }
};
exports.otherQueries = {
    patientStatementOfConsentFyrms: {
        interpretation: {
            vocab: "ktx",
            code: "signed_statement_of_consent_fyrms"
        }
    },
    patientStatementOfConsentOvsz: {
        interpretation: {
            vocab: "ktx",
            code: "signed_statement_of_consent_ovsz"
        }
    },
    accessStatement: {
        interpretation: {
            vocab: "ktx",
            code: "access_statement"
        }
    },
    antropometricsExamination: {
        interpretation: {
            vocab: "ktx",
            code: "antropometrics_examination"
        }
    },
    bloodGroup: {
        interpretation: {
            vocab: "ktx",
            code: "blood_group"
        }
    },
    cardiovascularDisease: {
        interpretation: {
            vocab: "ktx",
            code: "cardiovascular_disease"
        }
    },
    graftlossStatement: {
        interpretation: {
            vocab: "ktx",
            code: "graftloss_statement"
        }
    },
    haemostaseology: {
        interpretation: {
            vocab: "ktx",
            code: "haemostaseology"
        }
    },
    nephrectomyGraftectomy: {
        interpretation: {
            vocab: "ktx",
            code: "nephrectomy_graftectomy"
        }
    },
    otherDisorder: {
        interpretation: {
            vocab: "ktx",
            code: "other_disorder"
        }
    },
    otherSurgicalIntervention: {
        interpretation: {
            vocab: "ktx",
            code: "other_surgical_intervention"
        }
    },
    pregnanciesAndChildrenStatement: {
        interpretation: {
            vocab: "ktx",
            code: "pregnancies_and_children_statement"
        }
    },
    previousOtherOrganTransplantationStatement: {
        interpretation: {
            vocab: "ktx",
            code: "previous_other_organ_transplantation_statement"
        }
    },
    renalAnaemiaHematologyStatement: {
        interpretation: {
            vocab: "ktx",
            code: "renal_anaemia_hematology_statement"
        }
    },
    renalReplacementTherapyStatement: {
        interpretation: {
            vocab: "ktx",
            code: "renal_replacement_therapy_statement"
        }
    },
    statusByNephrologist: {
        interpretation: {
            vocab: "ktx",
            code: "patient_status_by_nephrologist"
        }
    },
    bloodPressure: {
        interpretation: {
            vocab: "ktx",
            code: "blood_pressure"
        }
    }
};
exports.queries = {
    ...exports.qs,
    ...exports.preImmunisationQueries,
    ...exports.viralSerologyQueries,
    ...exports.waitingListQueries,
    ...exports.medicalHistoryQueries,
    ...exports.covidQueries,
    ...exports.labProcedureQueries,
    ...exports.imagingProcedureQueries,
    ...exports.consultationQueries,
    ...exports.tomourResearchQueries,
    ...exports.cardiologyQueries,
    ...exports.otherQueries
};
